export const SIZE = {
  small: 'small',
  big: 'big',
};